module.exports = __webpack_public_path__ + "img/data-item4-1.acbe69a.png";